import React, { FC } from "react";

import { IButtonProps } from "@/components/Button";
import { ModalButton } from "@/views/components/Modal";

import { CompanyLogoEditDialogModal, ICompanyLogoEditDialogModalProps } from "./CompanyLogoEditDialogModal";

interface ICompanyLogoEditButtonProps extends Omit<IButtonProps, "ref"> {
  dialogProps: ICompanyLogoEditDialogModalProps;
}

export const CompanyLogoEditButton: FC<ICompanyLogoEditButtonProps> = ({ dialogProps, ...buttonProps }) => {
  return (
    <ModalButton
      openable={CompanyLogoEditDialogModal}
      openableProps={{ size: "xxs", ...dialogProps }}
      testName="edit-company-logo"
      {...buttonProps}
    />
  );
};
